import React = require('react');
import { useEffect, useState } from 'react';
import { Field, InjectedFormProps } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';
import { renewalTypeSelectionEnum } from '../../../../components/YourRenewal';

interface IYourRenewalProps extends InjectedFormProps {
  formPath: string;
  allowAutoRenewal: boolean;

  change(field: string, value: any): void;

  renderDefinition(name: string, useProvidedString?: any): any;

  renewalStatus: renewalTypeSelectionEnum;
  defaultSelected?: renewalTypeSelectionEnum;
  ignorePermissions?: boolean;
}

export const YourRenewal = ({
                              formPath,
                              allowAutoRenewal,
                              renderDefinition,
                              renewalStatus,
                              change,
                              defaultSelected = null,
                              ignorePermissions = false,
                            }: IYourRenewalProps) => {

  const [showOption, setShowOption] = useState(false);

  useEffect(() => {
    change(formPath, defaultSelected)
  }, []);

  const changeShowRenewalOptions = () => {
    setShowOption(!showOption)
  }

  const isRenewalManual = renewalStatus && renewalStatus === renewalTypeSelectionEnum.MANUAL;
  const definition = renderDefinition('Renewal Type', 'We need to save your card details in order to auto-renew');

  return (
    <div className={'your-renewal-container'}>
      <div>
        Your Renewal: To keep you protected your policy is set to renew automatically using the payment details you
        provide. You can
        change your auto-renewal preference at anytime during your policy term by contacting us by phone, online or now
        by clicking <span className={'change-renewal-setting'} onClick={changeShowRenewalOptions}>here</span>.
      </div>
      {showOption && (
        <div className={'renewal-preferences-container'}>
          <div className="renewal-preferences-selection-container">
            <div className={renewalStatus === 'auto' ? 'box selected-trip-type' : 'box'}>
              <Field
                name={formPath}
                type="radio"
                value={'auto'}
                complexValue={true}
                component={FieldFormControl}
                validate={[isRequired]}
                disabled={!allowAutoRenewal && !ignorePermissions}
              >
                <div className={`trip-type-btn`}>
                  <div className={'trip-type-selection-container'}>
                    <div className={'title'}
                         style={!allowAutoRenewal && !ignorePermissions ? { opacity: '0.7' } : { opacity: '1' }}> Auto-renewal on
                      {!allowAutoRenewal && !ignorePermissions ? <span>{definition}</span> : ''}
                    </div>
                  </div>
                </div>
              </Field>
            </div>
          </div>
          <div className="renewal-preferences-selection-container">
            <div className={renewalStatus === 'manual' ? 'box selected-trip-type' : 'box'}>
              <Field
                name={formPath}
                type="radio"
                value={'manual'}
                complexValue={true}
                component={FieldFormControl}
                validate={[isRequired]}
              >
                <div className={`trip-type-btn`}>
                  <div className={'trip-type-selection-container'}>
                    <div className={'title'}>{'Auto-renewal off'}</div>
                    {isRenewalManual && (
                      <div className={'sub-text'}>
                        {' By removing the auto-renewal feature your cover will end on your renewal date, even if you are on\n' +
                          '                    a trip. This could leave you without cover for emergency medical expenses or unable to make a\n' +
                          '                    claim should you need to cancel or cut short your trip.'}
                      </div>
                    )}
                  </div>
                </div>
              </Field>
            </div>
          </div>
        </div>
      )}
    </div>
  )


}
